<template>
    <router-link :to="to" tag="button" class="btn btn--white">
        <slot></slot>
    </router-link>
</template>
<script>
export default {
    props: {
        to: {
            type: Object,
            required: false
        }
    }
};
</script>
